import lightbox from 'lightbox2';

document.addEventListener('turbo:load', function() {
  lightbox.init();
});